export enum Type {
  COHORT_RESPONSE_SAVE_REQUEST = 'app/survey/COHORT_RESPONSE_SAVE_REQUEST',
  COHORT_RESPONSE_SAVE_SUCCESS = 'app/survey/COHORT_RESPONSE_SAVE_SUCCESS',
  COHORT_RESPONSE_SAVE_FAILURE = 'app/survey/COHORT_RESPONSE_SAVE_FAILURE',

  COHORT_SET_SURVEY_DATA = 'app/survey/COHORT_SET_SURVEY_DATA',

  COHORT_SURVEY_STATUS_GET_SUCCESS = 'app/survey/COHORT_SURVEY_STATUS_GET_SUCCESS',
}
